<template>
  <div class="contents">
    <div class="d-flex section-title">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">生徒管理 – 学習履歴</p>
    </div>

    <!-- 1st group -->
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row"><b>生徒名：</b></th>
            <td>
              <b>{{ currentStudentName }}</b>
            </td>
            <td />
          </tr>
          <tr>
            <th scope="row">所属教場:</th>
            <td>{{ currentSchoolName }}</td>
            <td>所属ブランド:</td>
            <td>{{ currentBrandName }}</td>
          </tr>
          <tr>
            <th scope="row">学習中（極 - 図形）:</th>
            <td>{{ currentTeachingMaterialShape }}</td>
            <td>学習中（極 - 数）:</td>
            <td>{{ currentTeachingMaterialAlgebra }}</td>
          </tr>
          <tr>
            <th scope="row">学習中（国語）:</th>
            <td>{{ currentTeachingMaterialJapanese }}</td>
            <th>学習中（遊）:</th>
            <td>{{ currentTeachingMaterialKidsMathematics }}</td>
          </tr>
          <tr>
            <th scope="row">学習中（悟）:</th>
            <td>{{ currentTeachingMaterialAdvancedMathematics }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 2nd group -->
    <ul class="nav nav-tab-gray nav-tab-gray-top">
      <li class="nav-item" id="tabmenu" data-toggle="tab">
        <a class="tabitem-gray active">
          <img src="@/assets/images/Icon material-message.png" alt="" />
          メッセージ
        </a>
      </li>
    </ul>
    <div class="container container-gray">
      <div class="table-wrapper-scroll-y">
        <b-table
          ref="messaging-table"
          class="messaging-table"
          responsive
          :items="messagingHistory"
          :fields="messagingHistoryFields"
          thead-class="d-none"
        >
          <template v-slot:cell(date)="row">
            {{ messagingHistoryDatetimeDisplay(row.value) }}
          </template>
          >
          <template v-slot:cell(sender)="row">
            {{ messagingHistorySenderDisplay(row.value) }}
          </template>

          <template v-slot:cell(type)="row">
            {{ messagingHistoryTypeDisplay(row.value) }}
          </template>

          <template v-slot:cell(message)="{ item }">
            <pre
              class="messaging-text">{{ item.message }}<a class="hyper-text" @click="messagingHistoryDeletionConfirmation(item)">削除</a></pre>
          </template>
        </b-table>
      </div>
      <form class="form-inline" id="form-message">
        <div class="input-group" style="width: 100%;">
          <div class="input-group-prepend">
            <div class="input-group-text input-group-text-first">送信元:</div>
          </div>
          <div class="input-group-prepend">
            <input
              type="text"
              class="input-group-text input-group-text-name-white form-control form-message input-group-bottom"
              placeholder=""
              v-model="teacherName"
            />
          </div>
          <div class="input-group-prepend">
            <div class="input-group-text input-group-text-white">先生</div>
          </div>
          <input
            type="text"
            class="form-control form-message input-group-bottom"
            placeholder="ここにメッセージを入力"
            v-model="normalMessage"
          />
          <button
            :disabled="!normalMessage"
            type="button"
            class="btn btn-send input-group-bottom"
            @click="sendNormalMessage"
          >
            <img class="icon-send" src="@/assets/images/Icon ionic-md-send.png" />
          </button>
        </div>
      </form>
    </div>

    <!-- 3rd group -->
    <div class="container container-gray">
      <ul class="nav nav-tab-material">
        <li class="nav-item navitem-material" id="tabmenu" v-for="material in teachingMaterials" :key="material.code">
          <a class="tabitem-material" :class="{ active: material.currentTab }" @click="selectMaterialTab(material)">
            <img :src="teachingMaterialImgSrcBuilder(material.code)" alt="" />
          </a>
        </li>
      </ul>
      <div class="gray-content">
        学習中：{{ currentTeachingMaterialBaseOnMaterialLevel }}
        <div class="container-button">
          <span
            class="book-name-button"
            :class="[
              currentTeachingMaterialTab.teachingMaterial.code == '100' ? 'big-button' : '',
              { active: book.currentBook },
            ]"
            @click="selectBookTab(book)"
            v-for="book in currentTeachingBooks"
            :key="book.id"
          >
            <button type="button" :class="book.enable ? 'green' : 'gray'" :disabled="!book.enable">
              {{ book.name }}
            </button>
          </span>
        </div>
      </div>

      <form class="d-flex form-inline form-bottom">
        <ul class="nav nav-tabs nav-tabs-bottom-left">
          <li class="d-flex nav-item" id="inclass_tab_menu">
            <a
              class="nav-link tabitem nav-cursor"
              :class="{ active: inLearningProgressTab }"
              @click="selectInnerTab(INNER_TABS.LEARNING_STATUS_TAB)"
            >
              学習状況
            </a>
          </li>
          <li class="d-flex nav-item" id="inclass_tab_menu">
            <a
              class="nav-link tabitem nav-cursor"
              :class="{ active: currentInnerTab == INNER_TABS.TEST_STATUS_TAB }"
              @click="selectInnerTab(INNER_TABS.TEST_STATUS_TAB)"
            >
              確認テスト・進級テスト
            </a>
          </li>
        </ul>

        <div class="form-group ml-auto" v-if="inLearningProgressTab">
          <template v-if="hasCurrentLevelType">
            <button
              type="button"
              class="btn-sm-level nav-tabs-button"
              @click="scrollToExtraTab(EXTRA_TABS.ADVANCED_TAB)"
            >
              進級させる
            </button>
            <button
              type="button"
              class="btn-sm-level nav-tabs-button"
              @click="scrollToExtraTab(EXTRA_TABS.NOT_ADVANCED_TAB)"
            >
              進級させない
            </button>
          </template>
          <button type="button" class="btn-sm-level nav-tabs-button" @click="createCertificatePDF()">賞状発行</button>
        </div>
        <div class="form-group ml-auto" v-else>
          <button type="button" class="btn-sm-level nav-tabs-button" @click="createCertificatePDF()">賞状発行</button>
        </div>
      </form>

      <div class="d-flex form-inline learning-explain">
        {{ currentTeachingMaterialTabName }} {{ currentTeachingBookTabName }}
        <div class="form-group ml-auto" v-if="inLearningProgressTab">
          <span class="square">1</span><label class="square-explain">・・・学習完了</label>
          <span class="square square-green">1</span><label class="square-explain">・・・強制単元終了</label>
          <span class="square square-gray">1</span><label class="square-explain">・・・学習未完了</label>
        </div>
      </div>
      <template v-if="inLearningProgressTab">
        <LearningProgressTable :items="currentTeachingBookParts" :fields="learningFields" />
      </template>
      <template v-else>
        <TestProgressTable
          :items="currentTeachingTestHistory"
          :fields="testResultFields"
          :currentTeachingMaterialTabName="currentTeachingMaterialTabName"
          :currentTeachingBookTabName="currentTeachingBookTabName"
        />
      </template>
    </div>

    <!-- 4th group -->
    <template v-if="hasCurrentLevelType">
      <ul ref="extra_tab" class="nav nav-tab-gray nav-tab-gray-top">
        <li class="nav-item" id="tabmenu">
          <a
            class="tabitem-gray"
            :class="{ active: currentExtraTab == EXTRA_TABS.ADVANCED_TAB }"
            @click="selectExtraTab(EXTRA_TABS.ADVANCED_TAB)"
          >
            <img src="@/assets/images/Icon material-subdirectory-arrow-right.png" alt="" />進級させる
          </a>
        </li>
        <li class="nav-item" id="tabmenu">
          <a
            class="tabitem-gray"
            :class="{ active: currentExtraTab == EXTRA_TABS.NOT_ADVANCED_TAB }"
            @click="selectExtraTab(EXTRA_TABS.NOT_ADVANCED_TAB)"
          >
            <img src="@/assets/images/Icon material-arrow_back.png" alt="" width="" />進級させない
          </a>
        </li>
      </ul>
      <div class="container container-gray">
        <div class="gray-content">
          <template v-if="currentExtraTab == EXTRA_TABS.ADVANCED_TAB">
            <b>{{ currentStudentName }}</b>
            さんを
            <b>{{ currentNextLevelTypeDisplay }}</b>
            に進級させますか？（進級させない場合は別のタブに移動してください。） <br /><br />
            メッセージを追加、編集する場合は下欄に入力してください。
          </template>
          <template v-if="currentExtraTab == EXTRA_TABS.NOT_ADVANCED_TAB">
            <NotAdvanceClass :currentTeachingBookTab="currentTeachingBookTab" :currentStudent="currentStudent" />
          </template>
        </div>
        <form class="form-inline" id="form-message-extra">
          <div class="input-group" style="width: 100%;">
            <div class="input-group-prepend">
              <div class="input-group-text input-group-text-first">送信元:</div>
            </div>
            <div class="input-group-prepend">
              <input
                type="text"
                class="input-group-text input-group-text-name-white form-control form-message input-group-bottom"
                placeholder=""
                v-model="teacherName"
              />
            </div>
            <div class="input-group-prepend">
              <div class="input-group-text input-group-text-white">先生</div>
            </div>
            <template v-if="currentExtraTab == EXTRA_TABS.ADVANCED_TAB">
              <input
                type="text"
                class="form-control form-message input-group-bottom"
                placeholder="ここにメッセージを入力"
                v-model="promotedMessage"
              />
            </template>
            <template v-if="currentExtraTab == EXTRA_TABS.NOT_ADVANCED_TAB">
              <input
                type="text"
                class="form-control form-message input-group-bottom"
                placeholder="ここにメッセージを入力"
                v-model="notPromotedMessage"
              />
            </template>
            <div class="input-group-button-red">
              <template v-if="currentExtraTab == EXTRA_TABS.ADVANCED_TAB">
                <button type="button" class="btn btn-send-red input-group-bottom" @click="approveAvancement">
                  進級させる
                </button>
              </template>
              <template v-if="currentExtraTab == EXTRA_TABS.NOT_ADVANCED_TAB">
                <button type="button" class="btn btn-send-red input-group-bottom" @click="instructWithoutAdvancement">
                  進級させずに復習を指示
                </button>
              </template>
            </div>
          </div>
        </form>
      </div>
    </template>

    <PopUpHolder
      ref="popup_holder"
      show-red-button
      no-close-on-esc
      no-close-on-backdrop
      :red-button-title="popupTypeAdvance ? '進級させる' : '復習を指示'"
      green-button-title="戻る"
      @redClick="advancementPopupConfirmed"
      @greenClick="popupRejected"
    >
      <template v-slot:header v-if="popupTypeAdvance">進級処理</template>
      <template v-slot:header v-else>復習を指示</template>
      <template v-slot:body v-if="popupTypeAdvance">
        本当に進級させますか？一度進級させると元には戻せません。
        <template v-if="shouldShowG4ShapeAlert">
          <br />平面図形と空間図形が両方G3でない場合、G4には進級できません。
        </template>
      </template>
      <template v-slot:body v-else>進級させずに復習を指示しますか？</template>
    </PopUpHolder>

    <PopUpHolder
      ref="delete_message_popup_holder"
      show-red-button
      no-close-on-esc
      no-close-on-backdrop
      red-button-title="削除する"
      green-button-title="戻る"
      @redClick="deleteMessagePopupConfirmed"
      @greenClick="popupRejected"
    >
      <template v-slot:header>削除処理</template>
      <template v-slot:body>
        <p>このメッセージを削除しますか？</p>
        <p>
          {{ selectedMessage.date }}<span class="delete-message-sender-space">{{ selectedMessage.sender }}</span
          ><br />
          「 {{ selectedMessage.message }} 」
        </p>
      </template>
    </PopUpHolder>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import LearningProgressTable from '@/views/students/forms/LearningProgressTable.vue';
import TestProgressTable from '@/views/students/forms/TestProgressTable.vue';
import NotAdvanceClass from '@/views/students/forms/NotAdvanceClass.vue';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import {
  basicPresent,
  basicDatetime,
  basicFieldPresent,
  basicSubFieldPresent,
  basicTeachingMaterialShapeDisplay,
  basicTeachingMaterialAlgebraDisplay,
  basicTeachingMaterialJapaneseDisplay,
  basicTeachingMaterialKidsMathematicsDisplay,
  basicTeachingMaterialAdvancedMathematicsDisplay,
  basicLevelDisplay,
} from '@/presenters/fields';
import map from 'lodash/map';
import find from 'lodash/find';
import filter from 'lodash/filter';
import first from 'lodash/first';
import replace from 'lodash/replace';
import isEmpty from 'lodash/isEmpty';
import JQuery from 'jquery';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('student_history/fetchLearningHistory', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    LearningProgressTable,
    TestProgressTable,
    NotAdvanceClass,
    PopUpHolder,
  },
  data() {
    const messagingHistoryFields = [
      {
        key: 'date',
      },
      {
        key: 'sender',
      },
      {
        key: 'type',
      },
      {
        key: 'message',
      },
    ];
    const learningFields = [
      {
        key: 'id',
        tdAttr: { width: 20 },
      },
      {
        key: 'name',
        tdAttr: { width: 100 },
      },
      {
        key: 'percentage_bar',
        tdAttr: { width: 150 },
      },
      {
        key: 'percentage',
        tdAttr: { width: 20 },
      },
      {
        key: 'bookChapterId',
        tdAttr: { width: 50 },
      },
      {
        key: 'askTeacher',
        tdAttr: { width: 100 },
      },
      {
        key: 'teacherNotify',
        tdAttr: { width: 100 },
      },
      {
        key: 'action',
        expanded: false,
        tdAttr: { width: 20 },
      },
    ];
    const testResultFields = [
      {
        key: 'group',
        tdAttr: { width: 60 },
      },
      {
        key: 'title',
        tdAttr: { width: 150 },
      },
      {
        key: 'testDateTime',
        tdAttr: { width: 150 },
      },
      {
        key: 'testScore',
        tdAttr: { width: 80 },
      },
      {
        key: 'comment',
        tdAttr: { width: 200 },
      },
      {
        key: 'teacherName',
        tdAttr: { width: 150 },
      },
      {
        key: 'action',
        tdAttr: { width: 150 },
      },
    ];
    const INNER_TABS = {
      LEARNING_STATUS_TAB: 'learning_status_tab',
      TEST_STATUS_TAB: 'test_status_tab',
    };
    const EXTRA_TABS = {
      ADVANCED_TAB: 'advanced_tab',
      NOT_ADVANCED_TAB: 'not_advanced_tab',
    };
    const selectedMessage = {
      id: null,
      date: '',
      sender: '',
      message: '',
    };
    return {
      messagingHistoryFields,
      learningFields,
      testResultFields,
      INNER_TABS,
      currentInnerTab: INNER_TABS.LEARNING_STATUS_TAB,
      EXTRA_TABS,
      currentExtraTab: EXTRA_TABS.ADVANCED_TAB,
      selectedMessage,
      popupTypeAdvance: true,
      normalMessage: null,
      promotedMessage: null,
      notPromotedMessage: null,
      teacherName: null,
    };
  },
  computed: {
    currentStudent() {
      return this.student;
    },
    currentStudentName() {
      return basicFieldPresent(this.currentStudent, 'name');
    },
    currentSchoolName() {
      return basicSubFieldPresent(this.currentStudent, 'school', 'name');
    },
    currentBrandName() {
      return basicSubFieldPresent(this.currentStudent, 'brand', 'name');
    },
    currentTeachingMaterialShape() {
      return basicTeachingMaterialShapeDisplay(this.currentStudent.currentLevelMaterials);
    },
    currentTeachingMaterialAlgebra() {
      return basicTeachingMaterialAlgebraDisplay(this.currentStudent.currentLevelMaterials);
    },
    currentTeachingMaterialJapanese() {
      return basicTeachingMaterialJapaneseDisplay(this.currentStudent.currentLevelMaterials);
    },
    currentTeachingMaterialKidsMathematics() {
      return basicTeachingMaterialKidsMathematicsDisplay(this.currentStudent.currentLevelMaterials);
    },
    currentTeachingMaterialAdvancedMathematics() {
      return basicTeachingMaterialAdvancedMathematicsDisplay(this.currentStudent.currentLevelMaterials);
    },
    teachingMaterials() {
      return map(this.learningHistory, 'teachingMaterial');
    },
    currentTeachingMaterialTab() {
      return find(this.learningHistory, (history) => history.teachingMaterial.currentTab);
    },
    currentTeachingMaterialTabName() {
      if (isEmpty(this.currentTeachingMaterialTab)) {
        return;
      } else {
        return this.currentTeachingMaterialTab.teachingMaterial.name;
      }
    },
    currentTeachingBooks() {
      if (isEmpty(this.currentTeachingMaterialTab)) {
        return [];
      } else {
        return this.currentTeachingMaterialTab.teachingBooks;
      }
    },
    currentTeachingBookTab() {
      if (isEmpty(this.currentTeachingBooks)) {
        return {};
      } else {
        return find(this.currentTeachingBooks, (book) => book.enable && book.currentBook);
      }
    },
    currentTeachingBookTabName() {
      if (isEmpty(this.currentTeachingBookTab)) {
        return;
      } else {
        return this.currentTeachingBookTab.name;
      }
    },
    currentTeachingBookParts() {
      if (isEmpty(this.currentTeachingBookTab)) {
        return [];
      } else {
        return this.currentTeachingBookTab.bookParts;
      }
    },
    currentTeachingTestHistory() {
      if (isEmpty(this.currentTeachingBookTab)) {
        return [];
      } else {
        let testResults = [];
        const bookTestHistory = {
          group: '',
          title: '進級テスト',
          results: this.currentTeachingBookTab.testHistory,
        };
        testResults.push(bookTestHistory);
        if (!isEmpty(this.currentTeachingBookParts)) {
          this.currentTeachingBookParts.forEach((part) => {
            const bookPartTestHistory = {
              group: part.id,
              title: part.name,
              results: part.testHistory,
            };
            testResults.push(bookPartTestHistory);
          });
        }
        return testResults;
      }
    },
    defaultPromotedMessage() {
      let message = 'に進級しました！おめでとう！';
      if (this.currentNextLevelTypeDisplay) {
        message = this.currentNextLevelTypeDisplay + message;
      }
      return message;
    },
    defaultNotPromotedMessage() {
      return '惜しかったね！次の単元や大問を復習しましょう！';
    },
    notPromotedContentBuilder() {
      let message = this.notPromotedMessage;
      this.notPromotedBooks.forEach((book) => {
        if (book.bookName && book.bookPartId && book.bookPartName && book.bookChapterName && book.bookBigQuestionName) {
          message += '\n';
          message += '・' + this.currentTeachingMaterialTabName;
          message += ' ' + book.bookName;
          message += ' ' + book.bookPartId + book.bookPartName;
          message += ' ' + book.bookChapterName;
          message += ' 大問' + book.bookBigQuestionName;
        }
      });
      return message;
    },
    currentTeachingMaterialBaseOnMaterialLevel() {
      if (isEmpty(this.currentTeachingMaterialTab)) return basicPresent(null);

      let currentLevelMaterials = this.currentStudent.currentLevelMaterials;
      if (isEmpty(currentLevelMaterials)) return basicPresent(null);

      let currentTeachingMaterialCode = this.currentTeachingMaterialTab.teachingMaterial.code;
      switch (currentTeachingMaterialCode) {
        case '400': {
          const materials = filter(currentLevelMaterials, (material) => material.level == 'level_1');
          return basicTeachingMaterialShapeDisplay(materials);
        }
        case '200': {
          const materials = filter(currentLevelMaterials, (material) => material.level == 'level_2');
          return basicTeachingMaterialAlgebraDisplay(materials);
        }
        case '300': {
          const materials = filter(currentLevelMaterials, (material) => material.level == 'level_4');
          return basicTeachingMaterialAlgebraDisplay(materials);
        }
        case '100': {
          const materials = filter(currentLevelMaterials, (material) => material.level.includes('level_3'));
          return basicTeachingMaterialShapeDisplay(materials);
        }
        case '700': {
          const materials = filter(currentLevelMaterials, (material) => material.level == 'level_7');
          return basicTeachingMaterialJapaneseDisplay(materials);
        }
        case '600': {
          const materials = filter(currentLevelMaterials, (material) => material.level == 'level_6');
          return basicTeachingMaterialKidsMathematicsDisplay(materials);
        }
        case '500': {
          const materials = filter(currentLevelMaterials, (material) => material.level == 'level_5');
          return basicTeachingMaterialAdvancedMathematicsDisplay(materials);
        }
        default:
          return basicPresent(null);
      }
    },
    currentLevelType() {
      if (isEmpty(this.currentTeachingMaterialTab)) return;
      if (isEmpty(this.currentTeachingBookTab)) return;

      let currentTeachingMaterialCode = this.currentTeachingMaterialTab.teachingMaterial.code;
      let currentStudentMaterialCodes = map(this.student.figuredTeachingMaterials, 'code');
      if (!currentStudentMaterialCodes.includes(currentTeachingMaterialCode)) return;

      switch (currentTeachingMaterialCode) {
        case '600': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 5).code;
          const pattern = /(\d{5})$/; // Ex: 40010#40010
          let match = studentLevel.match(pattern);
          if (!match) return;
          if (this.currentTeachingBookTab.id != match[1]) return;

          return 'level_6';
        }
        case '700': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 6).code;
          const pattern = /(\d{5})$/; // Ex: 51110#51110
          let match = studentLevel.match(pattern);
          if (!match) return;
          if (this.currentTeachingBookTab.id != match[1]) return;

          return 'level_7';
        }
        case '400': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 0).code;
          const pattern = /(\d{5})$/; // Ex: 11100#11090
          let match = studentLevel.match(pattern);
          if (!match) return;
          if (this.currentTeachingBookTab.id != match[1]) return;

          return 'level_1';
        }
        case '200': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 1).code;
          const pattern = /(\d{5})$/; // Ex: 21010#21010
          let match = studentLevel.match(pattern);
          if (!match) return;
          if (this.currentTeachingBookTab.id != match[1]) return;

          return 'level_2';
        }
        case '300': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 3).code;
          const pattern = /(\d{5})$/; // Ex: 22010#22010
          let match = studentLevel.match(pattern);
          if (!match) return;
          if (this.currentTeachingBookTab.id != match[1]) return;

          return 'level_4';
        }
        case '100': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 2).code;
          if (!studentLevel.includes(this.currentTeachingBookTab.id)) return;

          const bookIdPattern = /^(\d{5})#(\d{5})$/; // Ex: 12011#12012
          let match = studentLevel.match(bookIdPattern);
          if (!match) return; // Return if NOT match
          if (studentLevel == '12031#12032') {
            // 中学生の図形の極 G3 平面・中学生の図形の極 G3 空間の時
            return 'level_3';
          }
          if (this.currentTeachingBookTab.id == match[1]) {
            return 'level_3.1';
          } else if (this.currentTeachingBookTab.id == match[2]) {
            return 'level_3.2';
          } else {
            return 'level_3';
          }
        }
        case '500': {
          let studentLevel = find(this.currentStudent.levels, (level) => level.position == 4).code;
          const pattern = /(\d{5})$/; // Ex: 33010#33010
          let match = studentLevel.match(pattern);
          if (!match) return;
          if (this.currentTeachingBookTab.id != match[1]) return;

          return 'level_5';
        }
        default:
          return null;
      }
    },
    currentLevelTypeDisplay() {
      let levelDisplay = null;
      switch (this.currentLevelType) {
        case 'level_6': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 5);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_7': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 6);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_1': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 0);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_2': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 1);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_3': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 2);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_3.1': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 2);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_3.2': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 2);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_4': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 3);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
        case 'level_5': {
          const currentLevel = find(this.currentStudent.levels, (level) => level.position == 4);
          if (!isEmpty(currentLevel)) {
            levelDisplay = currentLevel.name;
          }
          break;
        }
      }
      return basicLevelDisplay(levelDisplay);
    },
    currentNextLevelTypeDisplay() {
      let levelDisplay = null;
      switch (this.currentLevelType) {
        case 'level_6': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 5).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
        case 'level_7': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 6).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
        case 'level_1': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 0).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
        case 'level_2': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 1).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
        case 'level_3': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 2).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
        case 'level_3.1': {
          const subLevels = find(this.currentStudent.levels, (level) => level.position == 2).subLevels;
          if (!isEmpty(subLevels)) {
            const nextLevel = find(subLevels, (level) => level.position == 0).nextLevel;
            if (!isEmpty(nextLevel)) {
              levelDisplay = nextLevel.name;
            }
          } else {
            const nextLevel = find(this.currentStudent.levels, (level) => level.position == 2).nextLevel;
            if (!isEmpty(nextLevel)) {
              levelDisplay = nextLevel.name;
            }
          }
          break;
        }
        case 'level_3.2': {
          const subLevels = find(this.currentStudent.levels, (level) => level.position == 2).subLevels;
          if (!isEmpty(subLevels)) {
            const nextLevel = find(subLevels, (level) => level.position == 1).nextLevel;
            if (!isEmpty(nextLevel)) {
              levelDisplay = nextLevel.name;
            }
          } else {
            const nextLevel = find(this.currentStudent.levels, (level) => level.position == 2).nextLevel;
            if (!isEmpty(nextLevel)) {
              levelDisplay = nextLevel.name;
            }
          }
          break;
        }
        case 'level_4': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 3).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
        case 'level_5': {
          const nextLevel = find(this.currentStudent.levels, (level) => level.position == 4).nextLevel;
          if (!isEmpty(nextLevel)) {
            levelDisplay = nextLevel.name;
          }
          break;
        }
      }
      return basicLevelDisplay(levelDisplay);
    },
    shouldShowG4ShapeAlert() {
      return this.currentLevelType == 'level_3.1' || this.currentLevelType == 'level_3.2';
    },
    hasCurrentLevelType() {
      if (this.currentLevelType) return true;

      return false;
    },
    hasNotCompletedBook() {
      const notCompletedBook = find(this.notPromotedBooks, (book) => book.bookBigQuestionId == null);
      if (notCompletedBook) return true;

      return false;
    },
    inLearningProgressTab() {
      return this.currentInnerTab == this.INNER_TABS.LEARNING_STATUS_TAB;
    },
    ...mapState({
      currentUser: (state) => state.auth.currentUser,
      teacher: (state) => state.teacher.teacher,
      student: (state) => state.student_history.student,
      messagingHistory: (state) => state.student_history.messagingHistory,
      learningHistory: (state) => state.student_history.learningHistory,
      messageType: (state) => state.student_history.messageType,
      notPromotedBooks: (state) => state.student_history.notPromotedBooks,
    }),
  },
  methods: {
    findStudentCurrentBookId(currentTeachingMaterialCode) {
      // 11020#11010などのコードから学習中の級コードを返す（→11010）
      switch (currentTeachingMaterialCode) {
        case '400': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 0).code;
          const studentLevelCurrentCode = studentLevelCode.slice(-5);
          return studentLevelCurrentCode;
        }
        case '200': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 1).code;
          const studentLevelCurrentCode = studentLevelCode.slice(-5);
          return studentLevelCurrentCode;
        }
        case '300': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 3).code;
          const studentLevelCurrentCode = studentLevelCode.slice(-5);
          return studentLevelCurrentCode;
        }
        case '100': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 2).code;
          // 12011#12021など平面#空間のコードの場合は平面（#の左側）を返し、12030#12040などGrade4以上の場合は学習中の級（#の右側）を返す
          if (studentLevelCode.slice(-1) != 0) {
            return studentLevelCode.slice(0, 5);
          } else {
            return studentLevelCode.slice(-5);
          }
        }
        case '700': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 6).code;
          const studentLevelCurrentCode = studentLevelCode.slice(-5);
          return studentLevelCurrentCode;
        }
        case '600': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 5).code;
          const studentLevelCurrentCode = studentLevelCode.slice(-5);
          return studentLevelCurrentCode;
        }
        case '500': {
          const studentLevelCode = find(this.currentStudent.levels, (level) => level.position == 4).code;
          const studentLevelCurrentCode = studentLevelCode.slice(-5);
          return studentLevelCurrentCode;
        }
        default:
          return null;
      }
    },
    selectMaterialTab(selectMaterial) {
      this.teachingMaterials.forEach((material) => {
        material.currentTab = false;
      });
      selectMaterial.currentTab = true;
      this.clearNotPromotedBooks();
      this.setDefaultPromotedMessage();
      this.setDefaultNotPromotedMessage();
      const studentCurrentBookId = this.findStudentCurrentBookId(selectMaterial.code);
      const index = this.currentTeachingBooks.findIndex((book) => book.id == studentCurrentBookId);
      if (index != -1) {
        this.selectBookTab(this.currentTeachingBooks[index]);
      }
    },
    selectBookTab(selectBook) {
      this.currentTeachingBooks.forEach((book) => {
        book.currentBook = false;
      });
      selectBook.currentBook = true;
      this.clearNotPromotedBooks();
      this.setDefaultPromotedMessage();
      this.setDefaultNotPromotedMessage();
    },
    setDefaultPromotedMessage() {
      this.promotedMessage = this.defaultPromotedMessage;
    },
    setDefaultNotPromotedMessage() {
      this.notPromotedMessage = this.defaultNotPromotedMessage;
    },
    setDefaultTeacherName() {
      if (this.currentUser.role == 'teacher') {
        this.teacherName = this.teacherNameDisplay(this.teacher.name);
      }
    },
    teachingMaterialImgSrcBuilder(materialCode) {
      switch (materialCode) {
        case '400':
          return require('@/assets/images/kyouzai_shape.png');
        case '200':
          return require('@/assets/images/kyouzai_numbers.png');
        case '100':
          return require('@/assets/images/kyouzai_junior_high_school_figure.png');
        case '300':
          return require('@/assets/images/kyouzai_junior_high_school_algebra.png');
        case '700':
          return require('@/assets/images/kyouzai_japanese.png');
        case '600':
          return require('@/assets/images/kyouzai_asobi.png');
        case '500':
          return require('@/assets/images/kyouzai_satori.png');
      }
    },
    selectInnerTab(tab) {
      this.$logger.debug('Select Inner Tab:' + tab);
      this.currentInnerTab = tab;
    },
    selectExtraTab(tab) {
      this.$logger.debug('Select Extra Tab:' + tab);
      this.currentExtraTab = tab;
    },
    scrollToExtraTab(tab) {
      this.$logger.debug('Scroll To Extra Tab:' + tab);
      this.currentExtraTab = tab;
      this.$refs['extra_tab'].scrollIntoView();
    },
    approveAvancement() {
      this.$logger.debug('Approve Advancement');
      this.popupTypeAdvance = true;
      this.$refs['popup_holder'].show();
    },
    instructWithoutAdvancement() {
      this.$logger.debug('Instruct but not Advancement');
      this.popupTypeAdvance = false;
      this.$refs['popup_holder'].show();
    },
    advancementPopupConfirmed() {
      if (this.popupTypeAdvance) {
        this.sendPromotedMessage();
      } else {
        this.sendNotPromotedMessage();
      }
      this.$logger.debug('Popup done');
    },
    popupRejected() {
      this.$logger.debug('Popup cancelled');
    },
    messagingHistoryDatetimeDisplay(date) {
      return basicDatetime(date);
    },
    messagingHistorySenderDisplay(sender) {
      let senderDisplay = this.teacherNameParser(sender);
      if (senderDisplay) senderDisplay += '先生';
      return basicPresent(senderDisplay);
    },
    messagingHistoryTypeDisplay(type) {
      switch (type) {
        case this.messageType.normal:
          return '通常：';
        case this.messageType.promoted:
          return '進級：';
        default:
          return '-：';
      }
    },
    messagingHistoryDeletionConfirmation(message) {
      this.selectedMessage.id = message.id;
      this.selectedMessage.date = basicDatetime(message.date);
      this.selectedMessage.sender = message.sender + '先生';
      this.selectedMessage.message = message.message;
      this.$refs['delete_message_popup_holder'].show();
    },
    teacherNameParser(name) {
      let teacherName = first(name.split(/\s/));
      teacherName = replace(teacherName, new RegExp('先生', 'g'), '');
      return teacherName;
    },
    teacherNameDisplay(name) {
      const nameDisplay = this.teacherNameParser(name);
      return nameDisplay;
    },
    sendNormalMessage() {
      if (this.normalMessage) {
        const message = {
          message: this.normalMessage,
          sender: this.teacherName,
          type: this.messageType.normal,
        };
        const params = {
          message,
          studentId: this.student.id,
          level: null,
        };
        this.sendMessage(params).then(() => {
          this.normalMessage = null;
          this.scrollMessageTableToBottom();
        });
      }
    },
    sendNotPromotedMessage() {
      const content = this.notPromotedContentBuilder;
      const message = {
        message: content,
        sender: this.teacherName,
        type: this.messageType.promoted,
      };
      const params = {
        message,
        studentId: this.student.id,
        level: null,
      };
      this.sendMessage(params).then(() => {
        this.setDefaultNotPromotedMessage();
        this.scrollMessageTableToBottom();
        this.clearNotPromotedBooks();
      });
    },
    sendPromotedMessage() {
      let content = this.defaultPromotedMessage;
      if (this.promotedMessage) {
        content = this.promotedMessage;
      }
      const message = {
        message: content,
        sender: this.teacherName,
        type: this.messageType.promoted,
      };
      const type = this.currentLevelType;
      const currentLevel = this.currentLevelTypeDisplay;
      if (!type || currentLevel == '―') {
        this.$logger.debug(
          'Failed to execute sendPromotedMessage: Expecting values for currentLevelType and currentLevelTypeDisplay.'
        );
        return;
      }
      const level = {
        type: type,
        current: currentLevel,
      };
      let params = {
        message,
        studentId: this.student.id,
        level,
      };
      this.sendMessage(params).then(() => {
        this.setDefaultPromotedMessage();
        window.location.reload();
      });
    },
    deleteMessagePopupConfirmed() {
      this.deleteMessage(this.selectedMessage.id).then(() => {
        window.location.reload();
      });
    },
    createCertificatePDF() {
      if (isEmpty(this.currentTeachingBookTab)) return;

      const bookId = this.currentTeachingBookTab.id;
      this.certificatePDF(bookId);
    },
    scrollMessageTableToBottom() {
      const tableHeight = JQuery('.messaging-table .table').height();
      JQuery('.messaging-table').animate({ scrollTop: tableHeight }, 400);
    },
    ...mapActions('student_history', ['sendMessage', 'deleteMessage', 'certificatePDF', 'clearNotPromotedBooks']),
  },
  mounted() {
    this.setDefaultTeacherName();
    this.setDefaultPromotedMessage();
    this.setDefaultNotPromotedMessage();
    this.scrollMessageTableToBottom();
  },
};
</script>

<style lang="scss" scoped>
.tabitem-material.active {
  opacity: 1;
}

.tabitem-material {
  opacity: 0.4;
  cursor: pointer;
}

.tabitem-gray.active {
  background-color: #eeeeee;
  border-bottom-width: 0px;
  margin-bottom: 10px;
  padding-bottom: 13px;
  cursor: pointer;
}
.tabitem-gray {
  background-color: #d6d6d6;
  border-bottom-width: 0px;
  margin-bottom: 10px;
  border-bottom-width: 1px;
  padding-bottom: 12px;
  cursor: pointer;
}
.nav-tab-gray-top {
  margin-top: 9px;
  margin-bottom: 8px;
}
.nav-tab-gray-bottom {
  margin-bottom: -3px;
}
.container-gray {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;

  .container-button {
    .book-name-button {
      margin: auto 5px;

      &.big-button {
        &.active {
          padding-bottom: 43px;
        }

        > button {
          max-width: 90px;
          height: 50px;
          vertical-align: top;
        }
      }

      &.active {
        border-bottom: 3px solid red;
        padding-bottom: 10px;
      }

      > button {
        color: white;
        border-radius: 6px;
        font-size: 13px;
        padding: 3px 15px;
        box-shadow: none;
        border: none;
        height: 25px;

        &.green {
          background-color: #42b195;
        }

        &.gray {
          background-color: #707070;
        }
      }
    }
  }
}
.input-group-prepend-flex {
  flex: 1 1 auto;
}
.input-group-text-name-flex {
  flex: auto;
}
.input-group-text-first {
  border-left: none;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 2px;
  border-bottom-width: 0px;
}
.input-group-text-name-white {
  background-color: white;
  font-size: 11px;
}
.input-group-border-right {
  border-right: 1.5px solid rgba(0, 0, 0, 0.1);
  padding: 3px;
}
.input-group-border-left {
  border-left: none;
}
.input-group-text {
  border-bottom-width: 0px;
}
.input-group-bottom {
  border-bottom-width: 0px;
}
.btn-send {
  border-right-width: 0px;
  border-bottom-right-radius: 2px;
  img.icon-send {
    margin-left: -5px;
  }
}
.btn-send-red {
  margin-top: 8px;
  margin-left: 10px;
  margin-bottom: 8px;
  margin-right: 10px;
  padding: 2px 15px;
  box-shadow: none;
  border: none;
  background-color: red;
  color: white;
  border-radius: 7px;
  height: 28px;
  font-size: 13px;
}
.input-group-button-red {
  margin-top: 2px;
  border: solid black;
  border-width: 0px;
  border-top-width: 1px;
  background-color: white;
}
.table-wrapper-scroll-y {
  margin-right: 1px;
}
.nav-tabs {
  border-radius: 0px;
  border-width: 0px;
  background-color: #eeeeee;
  padding-right: 1px;
}
.nav-tabs-holder {
  width: 400px;
}
.nav-tabs-button {
  width: 120px;
  margin-right: 10px;
}
.nav-tabs-bottom-left {
  width: 50%;
}
.form-bottom {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 1px;
}
.messaging-table,
.learning-table,
.test-table {
  margin-bottom: 0px;
  padding-left: 1px;
  padding-right: 1px;
}
.messaging-table {
  height: 160px;
  padding-top: 17px;
  /deep/ .table td {
    padding-top: 1px;
    padding-bottom: 1px;
  }
}
.messaging-text {
  white-space: pre-wrap;

  a {
    size: 100%;
    margin-left: 20px;
  }
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.delete-message-sender-space {
  margin-left: 20px;
}
.nav-cursor {
  cursor: pointer;
}
.square {
  padding: 1px 8px 1px 8px;
  background-color: #e75e58;
  color: white;
  margin-left: 10px;
  font-size: 10px;
}
.square-green {
  background-color: #42b195;
}
.square-gray {
  background-color: #707070;
}
.square-explain {
  font-size: 10px;
}
.learning-explain {
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: 1px;
  margin-right: 1px;
  padding-top: 10px;
  padding-left: 20px;
  padding-bottom: 10px;
  padding-right: 10px;
  background-color: white;
}
#form-message-extra {
  margin-bottom: 0;
}

.navitem-material {
  width: auto;
  text-align: center;
}

.navitem-material img {
  width: 65%;
  margin-right: 0;
}
</style>
